const errorCode = {
  '0': 'Erreur inconnue.',
  '1': 'Cette fonctionnalité n’est pas disponible pour le moment, merci de faire votre adhésion hors SPID.',
  '300': 'Le service ccns n\'est pas disponible.',
  '401': 'Vous n\'êtes pas autorisé à accéder à cette page',
  '404': 'Page non trouvée.'
};

export default errorCode;
